import CaptainPlanResource from "./captainPlan.resource";

const captainPlanModule = angular
  .module("app.resources.captainPlan", [])
  .service("CaptainPlan", CaptainPlanResource);

export default captainPlanModule;



// WEBPACK FOOTER //
// ./src/resources/captainPlan/captainPlan.module.js